"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthoContractChargeOverride_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var OrthoContractChargeSchedule_1 = require("./OrthoContractChargeSchedule");
var OrthoContractChargeOverride_Factory = /** @class */ (function () {
    function OrthoContractChargeOverride_Factory() {
    }
    OrthoContractChargeOverride_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            DueDate: Date_Factory_1.Date_Factory.CreateIncoming(model.DueDate, { ignoreTimePortion: true }),
            OrthoContractChargeSchedule: OrthoContractChargeSchedule_1.OrthoContractChargeSchedule_Factory.CreateIncoming(model.OrthoContractChargeSchedule),
            OrthoContractChargeScheduleId: model.OrthoContractChargeScheduleId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
        };
        return result;
    };
    OrthoContractChargeOverride_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            DueDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.DueDate, { ignoreTimePortion: true }),
            OrthoContractChargeSchedule: OrthoContractChargeSchedule_1.OrthoContractChargeSchedule_Factory.CreateOutgoing(model.OrthoContractChargeSchedule),
            OrthoContractChargeScheduleId: model.OrthoContractChargeScheduleId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
        };
        return result;
    };
    return OrthoContractChargeOverride_Factory;
}());
exports.OrthoContractChargeOverride_Factory = OrthoContractChargeOverride_Factory;
